var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tenants-avatar"}},[(_vm.tenantImage === null)?_c('div',{staticClass:"label-tenant fs-14",class:{'disabled': _vm.disabled},style:('--tenant-color:' + _vm.tenantColor)},[_c('model-short-name',{attrs:{"model":_vm.tenant}})],1):_c('img',{staticClass:"tenant-img img-fluid",attrs:{"src":_vm.tenantImage,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }